type PlatformCode = string;

// Unordered valid combinations (main & secondary can be in any order)
const validDynamicSettingPairs: [PlatformCode, PlatformCode][] = [
  ['SHOPIFY', 'TEMU'],
  ['SHOPIFY', 'TIKTOK'],
  ['SHOPIFY', 'MIRAKL'],
  ['WOOCOMMERCE', 'BACKMARKET'],
  ['WOOCOMMERCE', 'MIRAKL'],
  ['WOOCOMMERCE', 'TEMU'],
  ['WOOCOMMERCE', 'TIKTOK'],
  ['SHOPIFY', 'COMMERCEHUB'],
  ['SHOPIFY', 'KOGAN'],
  ['WOOCOMMERCE', 'KOGAN'],
  ['SHOPIFY', 'KOGANNZD'],
  ['WOOCOMMERCE', 'KOGANNZD'],
  ['WOOCOMMERCE', 'EBAY'],
  ['WOOCOMMERCE', 'AMAZONSELLER'],
  ['SHOPIFY', 'AMAZONSELLER'],
  ['SHOPIFY', 'EBAY'],
  ['ROYALMAIL', 'TEMU'],
  ['VEEQO', 'AMAZONSELLER'],
  ['VEEQO', 'TIKTOK'],
  ['VEEQO', 'SECRETSALES'],
  ['VEEQO', 'MIRAKL'],
  ['PRESTASHOP', 'AMAZONSELLER'],
  ['PRESTASHOP', 'EBAY'],
  ['VEEQO', 'TEMU'],
  ['SHOPIFY', 'WHATNOT'],
  ['PRESTASHOP', 'TEMU'],
  ['SHOPIFY', 'BACKMARKET'],
  ['VEEQO', 'EBAY'],
  ['VEEQO', 'KOGAN'],
  ['VEEQO', 'BACKMARKET'],
  ['PRESTASHOP', 'KOGAN'],
  ['PRESTASHOP', 'TIKTOK'],
  ['PRESTASHOP', 'MIRAKL'],
  ['PRESTASHOP', 'BACKMARKET'],
  ['ZohoInventory', 'EBAY'],
  ['ZohoInventory', 'AMAZON'],
  ['ZohoInventory', 'KOGAN'],
  ['ZohoInventory', 'WOOCOMMERCE'],
  ['ZohoInventory', 'MIRAKL'],
  ['ZohoInventory', 'TIKTOK'],
  ['ZohoInventory', 'TEMU'],
  ['ZohoInventory', 'BACKMARKET'],
  ['ZohoInventory', 'FLIPKART'],
  ['VEEQO', 'SHOPIFY'],
  ['VEEQO', 'BANDQ'],
  ['VEEQO', 'WIX'],
  ['SHOPIFY', 'BANDQ'],
  ['PRESTASHOP', 'BANDQ'],
  ['ZohoInventory', 'BANDQ'],
  ['WOOCOMMERCE', 'BANDQ'],
  ['ACUMATICA', 'COMMERCEHUB'],
  ['SHIPHERO', 'WIX'],
  ['SHIPHERO', 'AMAZONSELLER'],
  ['WIX', 'AMAZONSELLER'],
  ['WIX', 'TIKTOK'],
  ['SHOPIFY', 'SHEIN'],
  ['WOOCOMMERCE', 'SHEIN'],
  ['PRESTASHOP', 'SHEIN'],
  ['VEEQO', 'SHIEN'],
  ['ZohoInventory', 'SHIEN'],
  ['SHOPIFY', 'ETSY'],
  ['WOOCOMMERCE', 'ETSY'],
  ['PRESTASHOP', 'ETSY'],
  ['VEEQO', 'ETSY'],
  ['AMAZONMCF', 'SHOPIFY'],
  ['AMAZONMCF', 'TIKTOK'],
  ['AMAZONMCF', 'WIX'],
  //added by uma on 31-05-2024
  ['ODOO', 'TEMU'],
  ['ODOO', 'TIKTOK'],
  ['ODOO', 'BACKMARKET'],
  ['ODOO', 'MIRAKL'],
  ['ODOO', 'AMAZONSELLER'],
  ['ODOO', 'EBAY'],
  ['ODOO', 'KOGAN'],
  ['ODOO', 'SECRETSALES'],
  ['ODOO', 'FLIPKART'],
  ['ODOO', 'WHATNOT'],
  ['ODOO', 'ETSY'],
  ['ODOO', 'ECWID'],
  ['ODOO', 'KOGANNZD'],
  ['ODOO', 'BANDCAMP'],
  ['SHOPIFY', 'BANDCAMP'],
  ['PRESTASHOP', 'BANDCAMP'],
  ['WOOCOMMERCE', 'BANDCAMP'],
  ['ZohoInventory', 'BANDCAMP'],
  ['VEEQO', 'BANDCAMP'],
  ['ROYALMAIL', 'BANDCAMP'],
  ['ROYALMAIL', 'OnBuy'],
  ['ROYALMAIL', 'TIKTOK'],
  ['ODDO', 'NOON'],
  ['BUSINESS_CENTRAL_365', 'MIRAKL'],
  //added by uma on 13-11-2025
  ['SHOPIFY', 'FAIRE'],
  ['ODOO', 'FAIRE'],
  ['VEEQO', 'FAIRE'],
  ['WOOCOMMERCE', 'FAIRE'],
  ['PRESTASHOP', 'FAIRE'],
  ['ZohoInventory', 'FAIRE'],
  ['AMAZONMCF', 'FAIRE'],
  ['SHOPIFY', 'WALMART'],
  // added by uma on 14-11-2025
  ['ODOO', 'WALMART'],
  ['VEEQO', 'WALMART'],
  ['WOOCOMMERCE', 'WALMART'],
  ['PRESTASHOP', 'WALMART'],
  ['ZohoInventory', 'WALMART'],
  ['AMAZONMCF', 'WALMART'],
  ['SHOPIFY', 'WAYFAIR'],
  ['WOOCOMMERCE', 'WAYFAIR'],
  ['PRESTASHOP', 'WAYFAIR'],
  ['ZohoInventory', 'WAYFAIR'],
  ['VEEQO', 'WAYFAIR'],
  ['ODOO', 'WAYFAIR'],
  ['AMAZONMCF', 'WAYFAIR'],
  ['SHOPIFY', 'ALLEGRO'],
  ['PRESTASHOP', 'ALLEGRO'],
  ['WOOCOMMERCE', 'ALLEGRO'],
  ['VEEQO', 'ALLEGRO'],
  ['ODOO', 'ALLEGRO'],
  ['ZohoInventory', 'ALLEGRO'],
  ['AMAZONMCF', 'ALLEGRO'],
  ['SHOPIFY', 'REVERB'],
  ['WOOCOMMERCE', 'REVERB'],
  ['PRESTASHOP', 'REVERB'],
  ['ZohoInventory', 'REVERB'],
  ['VEEQO', 'REVERB'],
  ['ODOO', 'REVERB'],
  ['AMAZONMCF', 'REVERB'],
  //added on 16 dec
  ['ODOO', 'SHOPIFY'],
  ['QUICKBOOKS', 'FAIRE'],
  ['WOOCOMMERCE', 'COMMERCEHUB'],
  ['PRESTASHOP', 'COMMERCEHUB'],
  ['ZohoInventory', 'COMMERCEHUB'],
  ['ODOO', 'COMMERCEHUB'],
  ['VEEQO', 'COMMERCEHUB'],
  ['SHOPIFY', 'COMMERCHEHUB'],
  ['ERPNEXT', 'WOOCOMMERCE'],
  ['ERPNEXT', 'SHOPIFY'],
  //added in 21 jan 2026
  ['PRESTASHOP', 'DOCMORRIS'],
  ['SHOPIFY', 'DOCMORRIS'],
  ['WOOCOMMERCE', 'DOCMORRIS'],
  ['VEEQO', 'DOCMORRIS'],
  ['ZohoInventory', 'DOCMORRIS'],
  ['AMAZONMCF', 'DOCMORRIS'],
  ['ODOO', 'DOCMORRIS'],
  //added in 27 jan 2026
  ['PRESTASHOP', 'TRENDYOL'],
  ['SHOPIFY', 'TRENDYOL'],
  ['WOOCOMMERCE', 'TRENDYOL'],
  ['VEEQO', 'TRENDYOL'],
  ['ZohoInventory', 'TRENDYOL'],
  ['AMAZONMCF', 'TRENDYOL'],
  ['ODOO', 'TRENDYOL'],
  ['BUSINESS_CENTRAL_365', 'TRENDYOL'],
  ['BUSINESS_CENTRAL_365', 'COMMERCEHUB'],
  ['BUSINESS_CENTRAL_365', 'TEMU'],
  ['BUSINESS_CENTRAL_365', 'TIKTOK'],
  ['BUSINESS_CENTRAL_365', 'BACKMARKET'],
  ['BUSINESS_CENTRAL_365', 'MIRAKL'],
  ['BUSINESS_CENTRAL_365', 'AMAZONSELLER'],
  ['BUSINESS_CENTRAL_365', 'EBAY'],
  ['BUSINESS_CENTRAL_365', 'KOGANNZD'],
  ['BUSINESS_CENTRAL_365', 'KOGAN'],
  ['BUSINESS_CENTRAL_365', 'ETSY'],
  ['BUSINESS_CENTRAL_365', 'REVERB'],
  ['BUSINESS_CENTRAL_365', 'FAIRE'],
  ['BUSINESS_CENTRAL_365', 'BANDCAMP'],
  ['BUSINESS_CENTRAL_365', 'ALLEGRO'],
  ['BUSINESS_CENTRAL_365', 'SHOPIFY'],
]

/**
 * Checks if two platform codes form a valid dynamic setting pair,
 * regardless of their order (main/secondary).
 *
 * @param code1 - The first platform code (e.g., 'SHOPIFY')
 * @param code2 - The second platform code (e.g., 'TEMU')
 * @returns true if the combination is valid, false otherwise
 */
export function checkDynamicSettingPair(
  mainCodes: PlatformCode[] = [],
  secondaryCode?: PlatformCode
): boolean {
  // if (!mainCodes.length || !secondaryCode) return false;

  // return mainCodes.some(mainCode =>
  //   validDynamicSettingPairs.some(
  //     ([a, b]) =>
  //       (a === mainCode && b === secondaryCode) ||
  //       (a === secondaryCode && b === mainCode)
  //   )
  // );
  return Boolean(mainCodes.length && secondaryCode);
}
